"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeerGroup = void 0;
class PeerGroup {
    getResources() {
        return this.resources;
    }
    async init(resources) {
        this.resources = resources;
    }
    async getPeerGroupInfo() {
        return {
            id: this.getPeerGroupId(),
            localPeer: await this.getLocalPeer(),
            peerSource: await this.getPeerSource()
        };
    }
}
exports.PeerGroup = PeerGroup;
//# sourceMappingURL=PeerGroup.js.map